$(document).ready(function(){
  $('.testimonials-slick').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  $('.slider-portfolio').slick({
    infinite: false,
    draggable: true,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    variableWidth: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });
});

$(document).ready(function() {
  margenIndex();
});

$(window).on('load', function() {
  margenIndex();
});

$(window).resize(function(){
  margenIndex();
});

function margenIndex() {
  var margen = parseInt($('.portfolio-section .page-width').css('padding-left')) || 0;
  var ventanaAncho = $(window).width();

  if (ventanaAncho >= 480) {
    var negative = (margen) / 2;  // ahora es la mitad
  } else {
    var negative = (margen - 18) / 2; // también la mitad cuando es menor a 480px
  }

  $('.slider-portfolio .slick-dots').css({ 'margin-left': -negative });
}